define.alias("shared/components/shared/social/refresh-profile/snapchat", "settings/components/shared/social/refresh-profile/snapchat");